<div class="flex-nowrap">
  <!-- Console Toolbar -->
  <div
    fxLayout="row"
    fxLayoutGap="4px"
    fxLayoutAlign="start center"
  >
    <iframe
      class="analytics-iframe"
      width="100%"
      height="100%"
      frameBorder="0"
      [src]="analyticsUrl"
      *ngIf="analyticsUrl"
    ></iframe>
  </div>
</div>
